export default "__VITE_PUBLIC_ASSET__92abc9dd__"